export default __webpack_public_path__ + "LogoCodevWhite.6e06e25.png";